import {withStyles, Theme, InputBase} from '@material-ui/core';
import {WHITE_BACKGROUND_COLOR, BORDER_COLOR} from 'src/style/variable';
const CustomSelectField = withStyles((theme: Theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(0)
    },
    '& .MuiSelect-nativeInput': {
      opacity: 1,
      top: 0,
      bottom: 0,
      height: '2.3rem',
      justifyContent: 'center',
      border: `1px solid ${BORDER_COLOR} `,
      paddingLeft: '0.7rem',
      textOverflow: 'ellipsis',
      fontSize: '1rem',
      borderRadius: '4px',
      paddingRight: '1.5rem'
    },
    width: '100%',
    opacity: 1
  },
  input: {
    borderRadius: 0,
    position: 'relative',
    backgroundColor: WHITE_BACKGROUND_COLOR,
    fontSize: '1rem',
    width: '100%',
    textAlign: 'left',
    paddingLeft: '0.8125rem',
    '&:focus': {
      borderRadius: '4px'
    },
    height: '0.3rem'
  }
}))(InputBase);

export default CustomSelectField;
